import React from "react";
import styled from "styled-components";
import { ReactComponent as LoadingIcon } from "../../../assets/icons/Loading.svg";
import { theme } from "../../../theme";

const LoadingBox: React.FC = () => {
  return (
    <LoadingWrap>
      <Turn>
        <LoadingIcon />
      </Turn>
      <Text>업로드 중</Text>
      <OutBar>
        <InnerBar />
      </OutBar>
    </LoadingWrap>
  );
};
export default LoadingBox;
const LoadingWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100px;
  height: 100px;
  border: 1px dashed ${theme.colors.gray6};
  margin-right: 4px;
`;
const Turn = styled.div`
  width: 24px;
  height: 24px;
  animation: turn 1s infinite linear;
  @keyframes turn {
    100% {
      transform: rotate(360deg);
    }
  }
`;
const Text = styled.div`
  ${theme.typo.body.r14};
  color: ${theme.colors.black};
  margin: 4px 0;
`;
const OutBar = styled.div`
  position: relative;
  height: 2px;
  width: 71px;
  background-color: #eaebed;
  border-radius: 2px;
`;
const InnerBar = styled.div`
  position: absolute;
  width: 0px;
  height: 100%;
  background-color: ${theme.colors.mainPrimary3};
  border-radius: 2px;
  animation: gauge 3s linear both;
  @keyframes gauge {
    0% {
      width: 0%;
    }
    25% {
      width: 50%;
    }
    50% {
      width: 75%;
    }
    75% {
      width: 85%;
    }
    100% {
      width: 100%;
    }
  } ;
`;
